import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  FaUser, FaMapMarkerAlt, FaBirthdayCake, FaUniversity,
  FaEnvelope, FaPhone, FaCalendarPlus, FaVenusMars,
  FaStore, FaSave, FaCamera
} from "react-icons/fa";
import PageCreateHeader from "../../components/PageCreateHeader";

const EditKaryawan = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [outlets, setOutlets] = useState([]);

  const [formData, setFormData] = useState({
    fullname: "",
    tempat_lahir: "",
    tanggal_lahir: "",
    alamat: "",
    gender: "",
    pendidikan: "",
    no_hp: "",
    email: "",
    join_date: "",
    penempatan: "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    const fetchKaryawan = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/v1/employee?per_page&page&order_by&search`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (res.status === 200) {
          const employee = res.data.data.find(emp => emp.id === parseInt(id));
          if (employee) {
            setFormData({
              fullname: employee.full_name || "",
              tempat_lahir: employee.tempat_lahir || "",
              tanggal_lahir: employee.tanggal_lahir || "",
              alamat: employee.alamat || "",
              gender: employee.gender || "",
              pendidikan: employee.pendidikan || "",
              no_hp: employee.no_hp || "",
              email: employee.email || "",
              join_date: employee.join_date || "",
              penempatan: employee.outlet?.id ? String(employee.outlet.id) : "",
            });
          }
        }
      } catch (err) {
        console.error("Error fetching employee:", err);
      } finally {
        setLoading(false);
      }
    };

    const fetchOutlets = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/v1/outlet`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setOutlets(res.data.data);
      } catch (err) {
        console.error("Error fetching outlets:", err);
      }
    };

    fetchKaryawan();
    fetchOutlets();
  }, [id, token]);

  const validate = () => {
    let newErrors = {};

    Object.entries(formData).forEach(([key, value]) => {
      if (!value) newErrors[key] = "Field ini wajib diisi!";
    });

    if (formData.email && !/^\S+@\S+\.\S+$/.test(formData.email))
      newErrors.email = "Format email tidak valid!";

    if (formData.no_hp && !/^[0-9]+$/.test(formData.no_hp))
      newErrors.no_hp = "Nomor HP hanya boleh angka!";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    const payload = {
      fullname: formData.fullname,
      tempat_lahir: formData.tempat_lahir,
      tanggal_lahir: formData.tanggal_lahir,
      alamat: formData.alamat,
      gender: formData.gender,
      pendidikan: formData.pendidikan,
      no_hp: formData.no_hp,
      email: formData.email,
      join_date: formData.join_date,
      penempatan: parseInt(formData.penempatan),
    };

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/v1/employee/update/${id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        setShowSuccessModal(true);
        setTimeout(() => navigate("/enterprise/karyawan"), 2000);
      } else {
        alert("Gagal memperbarui data karyawan.");
      }
    } catch (err) {
      console.error("Update error:", err);
      alert(err.response?.data?.message || "Terjadi kesalahan saat mengupdate.");
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col space-y-6 p-6 w-full min-w-0">
        <PageCreateHeader
          icon={FaUser}
          title="Edit Karyawan"
          description="Memuat data karyawan..."
          breadcrumbs={[
            { label: "Enterprise", to: "/" },
            { label: "Karyawan", to: "/enterprise/karyawan" },
            { label: "Edit Karyawan" },
          ]}
        />
        <p className="text-gray-600">Loading...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col space-y-6 p-6 w-full min-w-0">
      <PageCreateHeader
        icon={FaUser}
        title="Edit Karyawan"
        description="Perbarui data dan penempatan karyawan"
        breadcrumbs={[
          { label: "Enterprise", to: "/" },
          { label: "Karyawan", to: "/enterprise/karyawan" },
          { label: "Edit Karyawan" },
        ]}
      />

      <div className="p-8 bg-white rounded-3xl shadow-xl border border-gray-100 w-full min-w-0">
        <form className="grid grid-cols-1 gap-5" onSubmit={handleSubmit}>
          {[
            { label: "Nama", name: "fullname", type: "text", icon: <FaUser /> },
            { label: "Tempat Lahir", name: "tempat_lahir", type: "text", icon: <FaMapMarkerAlt /> },
            { label: "Alamat", name: "alamat", type: "text", icon: <FaMapMarkerAlt /> },
            { label: "Tanggal Lahir", name: "tanggal_lahir", type: "date", icon: <FaBirthdayCake /> },
            { label: "Pendidikan", name: "pendidikan", type: "text", icon: <FaUniversity /> },
            { label: "Email", name: "email", type: "email", icon: <FaEnvelope /> },
            { label: "No. HP", name: "no_hp", type: "text", icon: <FaPhone /> },
            { label: "Join Date", name: "join_date", type: "date", icon: <FaCalendarPlus /> },
          ].map(({ label, name, type, icon }) => (
            <div key={name} className="">
              <label className="block text-sm font-medium text-gray-700 mb-1 flex items-center gap-2">
                {icon} {label}
              </label>

              <input
                type={type}
                name={name}
                value={formData[name]}
                onChange={handleChange}
                className={`w-full border rounded-xl px-4 py-2 bg-gray-50 focus:ring-2 focus:ring-blue-400 focus:outline-none shadow-sm transition
                  ${errors[name] ? "border-red-400" : "border-gray-300"}`}
              />

              {errors[name] && (
                <p className="text-red-500 text-xs mt-1">{errors[name]}</p>
              )}
            </div>
          ))}

          {/* Gender */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1 flex items-center gap-2">
              <FaVenusMars /> Gender
            </label>

            <select
              name="gender"
              value={formData.gender}
              onChange={handleChange}
              className={`w-full border rounded-xl px-4 py-2 bg-gray-50 focus:ring-2 focus:ring-blue-400 shadow-sm transition 
                ${errors.gender ? "border-red-400" : "border-gray-300"}`}
            >
              <option value="">Pilih Gender</option>
              <option value="male">Laki-laki</option>
              <option value="female">Perempuan</option>
            </select>

            {errors.gender && <p className="text-red-500 text-xs mt-1">{errors.gender}</p>}
          </div>

          {/* Outlet */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1 flex items-center gap-2">
              <FaStore /> Outlet (Penempatan)
            </label>

            <select
              name="penempatan"
              value={formData.penempatan}
              onChange={handleChange}
              className={`w-full border rounded-xl px-4 py-2 bg-gray-50 focus:ring-2 focus:ring-blue-400 shadow-sm transition 
                ${errors.penempatan ? "border-red-400" : "border-gray-300"}`}
            >
              <option value="">Pilih Outlet</option>
              {outlets.map(outlet => (
                <option key={outlet.id} value={outlet.id}>{outlet.name}</option>
              ))}
            </select>

            {errors.penempatan && <p className="text-red-500 text-xs mt-1">{errors.penempatan}</p>}
          </div>

          {/* SUBMIT BUTTON */}
          <div className="mt-4 w-full">
            <button
              type="submit"
              className="bg-green-600 hover:bg-green-700 text-white font-semibold px-6 py-3 w-full rounded-xl shadow-md flex items-center justify-center gap-2 transition active:scale-95"
            >
              <FaSave /> Simpan Perubahan
            </button>
          </div>
        </form>

        <div className="mt-10 pt-8 border-t border-gray-200 flex flex-col items-center w-full">
          <p className="text-sm font-medium text-gray-700 mb-4">Foto karyawan</p>
          <div className="w-36 h-36 mb-4 rounded-full overflow-hidden border-4 border-blue-300 shadow-lg">
            <img
              src="/default-profile.png"
              alt="Foto Karyawan"
              className="w-full h-full object-cover"
            />
          </div>
          <button
            type="button"
            className="flex items-center gap-2 bg-blue-50 hover:bg-blue-100 text-blue-700 font-medium px-4 py-2 rounded-lg shadow-sm transition"
          >
            <FaCamera /> Ganti Foto
          </button>
        </div>
      </div>

      {showSuccessModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div className="bg-white p-6 rounded-xl shadow-lg text-center animate-scaleIn">
            <h2 className="text-xl text-green-600 font-bold mb-2">Berhasil!</h2>
            <p className="text-gray-700">Data karyawan berhasil diperbarui.</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditKaryawan;
